import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse';

/**
 * no description
 */
export class CreateApiCredentialsApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Create a new api credentials
   * @param createApiCredentialsRequest The request body for creating api credentials
   */
  public async createApiCredentials(createApiCredentialsRequest: CreateApiCredentialsRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'createApiCredentialsRequest' is not null or undefined
    if (createApiCredentialsRequest === null || createApiCredentialsRequest === undefined) {
      throw new RequiredError("CreateApiCredentialsApi", "createApiCredentials", "createApiCredentialsRequest");
    }


    // Path Params
    const localVarPath = '/v1/api-credentials';

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(createApiCredentialsRequest, "CreateApiCredentialsRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class CreateApiCredentialsApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to createApiCredentials
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async createApiCredentialsWithHttpInfo(response: ResponseContext): Promise<HttpInfo<CreateApiCredentialsResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: CreateApiCredentialsResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "CreateApiCredentialsResponse", ""
      ) as CreateApiCredentialsResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: CreateApiCredentialsResponse = await response.body.json() as CreateApiCredentialsResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
